// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__wEz6j","cover":"section_cover__3KP-N","paragraph":"section_paragraph__2mlsG","span":"section_span__1UQh0","logo":"section_logo__2y9ad"};